<template>
  <div
    class="d-flex align-items-center justify-content-center position-relative h-100 w-100"
  >
    <video class="video-bg" id="video-element1" autoplay muted loop>
      <source
        src="~@/assets/images/pages/login/BG_Login.mp4"
        type="video/mp4"
      />
    </video>
    <div class="content-login">
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="position-relative w-100 h-100 text-center mt-2 mb-1">
              <img
                :src="forgetPasswordImg"
                alt="forgetPasswordImg"
                width="180"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div
              class="text-header font-large-1 text-bold text-black text-center"
            >
              Create New Password
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="m-auto">
              <b-form
                id="change-password"
                @submit.prevent="onSubmitChangePassword()"
              >
                <div class="add-on-border-group mt-10px" v-if="!newPassword">
                  <div class="font-medium-5 required">Current Password</div>
                  <b-input-group class="input-group-merge">
                    <b-form-input
                      v-model="formData.currentPassword"
                      :type="formData.currentPasswordFieldType"
                      :formatter="onCheckPasswordFormat"
                      placeholder="Current Password"
                      class="add-on-border-input"
                      id="current-password"
                      name="current-password"
                      autocomplete="current password"
                      @input="onCheckPasswordMatchOld"
                    />
                    <b-input-group-append is-text class="add-on-border">
                      <button
                        type="button"
                        class="btn-show-password"
                        @click="
                          onTogglePasswordVisibility(
                            passwordToggle.CURRENT_PASSWORD
                          )
                        "
                      >
                        <show-password
                          class="icon-show-password-svg"
                          v-if="
                            formData.currentPasswordFieldType === 'password'
                          "
                        />
                        <hide-password class="icon-show-password-svg" v-else />
                      </button>
                    </b-input-group-append>
                  </b-input-group>
                </div>
                <div class="add-on-border-group mt-10px">
                  <div class="font-medium-5 required">New Password</div>
                  <b-input-group class="input-group-merge">
                    <b-form-input
                      v-model="formData.newPassword"
                      :type="formData.newPasswordFieldType"
                      :formatter="onCheckPasswordFormat"
                      placeholder="New Password"
                      class="add-on-border-input"
                      id="new-password"
                      name="new-password"
                      autocomplete="current password"
                      @input="onCheckValidatePassword"
                    />
                    <b-input-group-append is-text class="add-on-border">
                      <button
                        type="button"
                        class="btn-show-password"
                        @click="
                          onTogglePasswordVisibility(
                            passwordToggle.NEW_PASSWORD
                          )
                        "
                      >
                        <show-password
                          class="icon-show-password-svg"
                          v-if="formData.newPasswordFieldType === 'password'"
                        />
                        <hide-password class="icon-show-password-svg" v-else />
                      </button>
                    </b-input-group-append>
                  </b-input-group>
                  <div
                    class="font-medium-5 text-danger"
                    v-if="passwordValidate.matchOld"
                  >
                    New password can not be the same as current password
                  </div>
                </div>
                <div class="add-on-border-group mt-10px">
                  <div class="font-medium-5 required">Confirm New Password</div>
                  <b-input-group class="input-group-merge">
                    <b-form-input
                      v-model="formData.confirmNewPassword"
                      :type="formData.confirmPasswordFieldType"
                      :formatter="onCheckPasswordFormat"
                      placeholder="Confirm New Password"
                      class="add-on-border-input"
                      id="confirm-password"
                      name="confirm-password"
                      autocomplete="current password"
                      @input="onCheckPasswordMatch"
                    />
                    <b-input-group-append is-text class="add-on-border">
                      <button
                        type="button"
                        class="btn-show-password"
                        @click="
                          onTogglePasswordVisibility(
                            passwordToggle.CONFIRM_NEW_PASSWORD
                          )
                        "
                      >
                        <show-password
                          class="icon-show-password-svg"
                          v-if="
                            formData.confirmPasswordFieldType === 'password'
                          "
                        />
                        <hide-password class="icon-show-password-svg" v-else />
                      </button>
                    </b-input-group-append>
                  </b-input-group>
                  <div class="text-error-wrp">
                    <div id="show-text-error">
                      <div>Error Message</div>
                    </div>
                  </div>
                </div>
                <div class="add-on-border-group mt-10px">
                  <div class="content-policy container mt-1">
                    <div class="row">
                      <div class="col-12">
                        <div class="font-medium-5 text-black text-bold">
                          Password must contain:
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="row">
                          <div class="col-1">
                            <div class="font-medium-4 text-black">
                              <img
                                v-if="passwordValidate.passwordLength != null"
                                :src="
                                  passwordValidate.passwordLength == true
                                    ? ValidIcon
                                    : passwordValidate.passwordLength == false
                                    ? InvalidIcon
                                    : ''
                                "
                                width="15"
                                height="15"
                              />
                            </div>
                          </div>
                          <div class="col-11">
                            <div class="font-medium-5 text-black">
                              At least 8 characters
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-1">
                            <div class="font-medium-4 text-black">
                              <img
                                v-if="passwordValidate.oneLower != null"
                                :src="
                                  passwordValidate.oneLower == true
                                    ? ValidIcon
                                    : passwordValidate.oneLower == false
                                    ? InvalidIcon
                                    : ''
                                "
                                width="15"
                                height="15"
                              />
                            </div>
                          </div>
                          <div class="col-11">
                            <div class="font-medium-5 text-black">
                              At least one lowercase letter (a-z).
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-1">
                            <div class="font-medium-4 text-black">
                              <img
                                v-if="passwordValidate.oneUpper != null"
                                :src="
                                  passwordValidate.oneUpper == true
                                    ? ValidIcon
                                    : passwordValidate.oneUpper == false
                                    ? InvalidIcon
                                    : ''
                                "
                                width="15"
                                height="15"
                              />
                            </div>
                          </div>
                          <div class="col-11">
                            <div class="font-medium-5 text-black">
                              At least one uppercase letter (A-Z).
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-1">
                            <div class="font-medium-4 text-black">
                              <img
                                v-if="passwordValidate.oneDigit != null"
                                :src="
                                  passwordValidate.oneDigit == true
                                    ? ValidIcon
                                    : passwordValidate.oneDigit == false
                                    ? InvalidIcon
                                    : ''
                                "
                                width="15"
                                height="15"
                              />
                            </div>
                          </div>
                          <div class="col-11">
                            <div class="font-medium-5 text-black">
                              At least one number (0-9)
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-1">
                            <div class="font-medium-4 text-black">
                              <img
                                v-if="passwordValidate.oneSpecial != null"
                                :src="
                                  passwordValidate.oneSpecial == true
                                    ? ValidIcon
                                    : passwordValidate.oneSpecial == false
                                    ? InvalidIcon
                                    : ''
                                "
                                width="15"
                                height="15"
                              />
                            </div>
                          </div>
                          <div class="col-11">
                            <div class="font-medium-5 text-black">
                              At least one special character
                              (!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~)
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-1">
                            <div class="font-medium-4 text-black">
                              <img
                                v-if="passwordValidate.match != null"
                                :src="
                                  passwordValidate.match == true
                                    ? ValidIcon
                                    : passwordValidate.match == false
                                    ? InvalidIcon
                                    : ''
                                "
                                width="15"
                                height="15"
                              />
                            </div>
                          </div>
                          <div class="col-11">
                            <div class="font-medium-5 text-black">
                              Password must be match
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="m-3 text-center">
                  <b-button
                    type="submit"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="success"
                    :disabled="!resolveResetPasswordButton || loading"
                    ><div class="font-medium-5">Reset Password</div>
                  </b-button>
                </div>
              </b-form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="copyright mt-1 mb-1">
      <img :src="logoChoco" width="150" class="logo-choco" />
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from "vee-validate";
// import { required, email } from '@validations';
import VuexyLogo from "@core/layouts/components/Logo.vue";
import EmailSvg from "@/@core/components/svg/common/EmailOpen.vue";
import LockSvg from "@/@core/components/svg/common/Lock.vue";
import ShowPassword from "@/@core/components/svg/common/ShowPassword.vue";
import HidePassword from "@/@core/components/svg/common/HidePassword.vue";
import ValidIcon from "@/assets/images/icons/valid.png";
import InvalidIcon from "@/assets/images/icons/invalid.png";
import logoChoco from "@/assets/images/logo/logo-choco.png";
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroupPrepend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BAlert,
  VBTooltip,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";

import useLoginAction from "@/views/pages/authentication/login/hooks/useLoginAction";
import { required, email, password } from "@validations";

import {
  getCurrentInstance,
  reactive,
  computed,
  onBeforeMount,
  ref,
} from "@vue/composition-api";
import forgetPasswordImg from "@/assets/images/pages/forgor-password/Forgot-Passwordl-BP.png";
export default {
  props: {
    loading: false,
    newPassword: false,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroupPrepend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BAlert,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
    EmailSvg,
    LockSvg,
    vSelect,
    ShowPassword,
    HidePassword,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },

  setup(props, { emit }) {
    const formData = reactive({
      currentPassword: "",
      newPassword: "",
      confirmNewPassword: "",
      currentPasswordFieldType: "password",
      newPasswordFieldType: "password",
      confirmPasswordFieldType: "password",
      changePassword: false,
    });

    const passwordValidate = reactive({
      passwordLength: null,
      oneLower: null,
      oneUpper: null,
      oneDigit: null,
      oneSpecial: null,
      matchOld: null,
      match: null,
    });

    const passwordToggle = {
      CURRENT_PASSWORD: 1,
      NEW_PASSWORD: 2,
      CONFIRM_NEW_PASSWORD: 3,
    };

    const onTogglePasswordVisibility = (password) => {
      switch (password) {
        case passwordToggle.CURRENT_PASSWORD:
          formData.currentPasswordFieldType =
            formData.currentPasswordFieldType === "password"
              ? "text"
              : "password";
          break;
        case passwordToggle.NEW_PASSWORD:
          formData.newPasswordFieldType =
            formData.newPasswordFieldType === "password" ? "text" : "password";
          break;
        case passwordToggle.CONFIRM_NEW_PASSWORD:
          formData.confirmPasswordFieldType =
            formData.confirmPasswordFieldType === "password"
              ? "text"
              : "password";
          break;
        default:
      }
    };

    const onCheckValidatePassword = (password) => {
      passwordValidate.passwordLength = false;
      passwordValidate.oneLower = false;
      passwordValidate.oneUpper = false;
      passwordValidate.oneDigit = false;
      passwordValidate.oneSpecial = false;
      passwordValidate.matchOld = false;
      passwordValidate.match = false;

      if (password.length >= 8) {
        passwordValidate.passwordLength = true;
      }
      if (/[a-z]/.test(password)) {
        passwordValidate.oneLower = true;
      }
      if (/[A-Z]/.test(password)) {
        passwordValidate.oneUpper = true;
      }
      if (/[0-9]/.test(password)) {
        passwordValidate.oneDigit = true;
      }
      if (/[_~`!@#$%^&*()_+=[\]\{}|;':",./]/.test(password)) {
        passwordValidate.oneSpecial = true;
      }

      if (!props.newPassword) {
        if (password && password == formData.currentPassword) {
          passwordValidate.matchOld = true;
        }
      }

      if (password && password == formData.confirmNewPassword) {
        passwordValidate.match = true;
      }
    };

    const onCheckPasswordMatchOld = (password) => {
      if (!password) return;

      if (password == formData.newPassword) passwordValidate.matchOld = true;
      else passwordValidate.matchOld = false;
    };

    const onCheckPasswordMatch = (password) => {
      if (!password) return;

      if (password == formData.newPassword) passwordValidate.match = true;
      else passwordValidate.match = false;
    };

    const onCheckPasswordFormat = (password) => {
      const pass = password.replace(
        /[^a-zA-Z0-9-_~`!@#$%^&*()_+=[\]\{}|;':",./]/g,
        ""
      );
      return pass;
    };

    const resolveResetPasswordButton = computed(() => {
      if (
        passwordValidate.passwordLength &&
        passwordValidate.oneLower &&
        passwordValidate.oneUpper &&
        passwordValidate.oneDigit &&
        passwordValidate.oneSpecial &&
        passwordValidate.match &&
        !passwordValidate.matchOld
      )
        return true;
      return false;
    });

    const onSubmitChangePassword = () => {
      let payload = {
        currentPassword: formData.currentPassword,
        newPassword: formData.newPassword,
        confirmNewPassword: formData.confirmNewPassword,
      };
      emit("onChangePassword", payload);
    };

    return {
      formData,
      passwordToggle,
      passwordValidate,
      onTogglePasswordVisibility,
      onCheckPasswordFormat,
      onCheckValidatePassword,
      onCheckPasswordMatch,
      onCheckPasswordMatchOld,
      onSubmitChangePassword,
      resolveResetPasswordButton,
      ValidIcon,
      InvalidIcon,
      logoChoco,
      forgetPasswordImg,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/css/override-styles/v-select.css";
@import "~@/assets/css/pages/login/login.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";

.text-header {
  /* border-bottom: 1px solid #dedede; */
  padding: 1rem;
}

.content-policy {
  background-color: #f2f5f5;
  border: 1px solid #e8e8e8;
  border-radius: 10px;
}

.content-login {
  width: 700px;
  height: auto;
  display: flex;
  /* overflow: hidden; */
  z-index: 1;
}
</style>
